import { render, staticRenderFns } from "./ViewRealtimeCall.vue?vue&type=template&id=6b6a4d78&scoped=true"
import script from "./ViewRealtimeCall.ts?vue&type=script&lang=ts&external"
export * from "./ViewRealtimeCall.ts?vue&type=script&lang=ts&external"
import style0 from "./ViewRealtimeCall.scss?vue&type=style&index=0&id=6b6a4d78&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a4d78",
  null
  
)

export default component.exports